export const REMIX_MENU_EXPERIMENT = 'cc-ce-maui-remix-menu-multivariant' as const;
export const REMIX_MENU_AA_EXPERIMENT = 'cc-ce-maui-remix-menu-multivariant-aa' as const;
export const REMIX_MENU_COHORT_PARAM = 'cohort' as const;
export const REMIX_MENU_AA_VARIANT_PARAM = 'variant' as const;
export const REMIX_MENU_CONTROL_COHORT = 'control' as const;
export const REMIX_MENU_INLINE_DROPDOWN_COHORT = 'variant1' as const;

/** Node types we never show Remix for. */
export const REMIX_DENY_LIST_V1: readonly string[] = [
	'mediaSingle',
	'mediaGroup',
	'media',
	'image',
	'extension',
	'bodiedExtension',
	'multiBodiedExtension',
	'embedCard',
	'blockCard',
	'inlineCard',
	// Source blocks
	'bodiedSyncBlock',
	// Reference blocks
	'syncBlock',
	'expand',
	'nestedExpand',
] as const;

const DENY_SET = new Set<string>(REMIX_DENY_LIST_V1);

/** True if this node type is in the remix deny list (restricted). */
export const isRemixRestrictedNodeType = (nodeType: string): boolean => DENY_SET.has(nodeType);

/**
 * True if the given extension key is in the provided allow list.
 *
 * The allow list is passed in by the consumer (e.g. Confluence) so that
 * feature-flag checks and product-specific decisions stay outside platform
 * code.
 */
export const isAllowedMBEExtensionForRemix = (
	extensionKey: string | undefined,
	allowList: ReadonlyArray<string>,
): boolean => extensionKey !== undefined && allowList.includes(extensionKey);
